import styled from 'styled-components';

export const IconContainer = styled.div`
  width: fit-content;
  height: auto;
  &:hover {
    cursor: pointer;
  }
`;
